"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const ServiceRegistry_1 = require("../Services/ServiceRegistry");
const ErrorHelpers_1 = require("../Utils/ErrorHelpers");
class DataTableReader {
    constructor(_id, _totalRowCount, _pageRowCount, _registryId) {
        this._id = _id;
        this._totalRowCount = _totalRowCount;
        this._pageRowCount = _pageRowCount;
        this._registryId = _registryId;
        this._pageCount = Math.ceil(_totalRowCount / _pageRowCount);
    }
    get totalRowCount() {
        return this._totalRowCount;
    }
    get pageCount() {
        return this._pageCount;
    }
    getPageAsync(pageNumber) {
        ErrorHelpers_1.ErrorHelpers.verifyRange(pageNumber, 0, this._pageCount);
        const service = ServiceRegistry_1.ApiServiceRegistry.get(this._registryId).getService("get-data-service" /* GetData */);
        return service.getPageAsync(this._id, pageNumber, this._pageRowCount);
    }
    getAllPagesAsync(maxRows) {
        return __awaiter(this, void 0, void 0, function* () {
            const firstPage = yield this.getPageAsync(0);
            maxRows = maxRows || this.totalRowCount;
            const rowsRequested = Math.min(maxRows, this.totalRowCount);
            const pagesRequested = Math.ceil(rowsRequested / this._pageRowCount);
            // Fetch up to 400 pages, with a default of 10,000 pageRowCount that gives us 4,000,000 rows
            const pagesToFetch = Math.min(pagesRequested, 400);
            const isDataLimited = pagesToFetch < pagesRequested;
            let remainingData = [];
            for (let i = 1; i < pagesToFetch; i++) {
                const page = yield this.getPageAsync(i);
                remainingData.push(page.data);
            }
            let fullData = firstPage.data.concat(...remainingData);
            // This slices the array only if maxRows has been set and is less than totalRowCount
            fullData.length = rowsRequested;
            return {
                name: firstPage.name,
                data: fullData,
                columns: firstPage.columns,
                totalRowCount: isDataLimited ? pagesToFetch * this._pageRowCount : rowsRequested,
                isTotalRowCountLimited: isDataLimited,
                isSummaryData: firstPage.isSummaryData,
            };
        });
    }
    releaseAsync() {
        const service = ServiceRegistry_1.ApiServiceRegistry.get(this._registryId).getService("get-data-service" /* GetData */);
        return service.releaseAsync(this._id);
    }
}
exports.DataTableReader = DataTableReader;
//# sourceMappingURL=GetDataTableReaderModels.js.map